module.exports = __webpack_public_path__ + "img/2.e7195ac9.png";